import styles from './ControlledSlider.module.css'
import React, { ReactElement } from 'react'
import { BasicStyledComponent } from 'shared-definitions/types'
import clsx from 'clsx'

interface ControlledSliderProps<T> extends BasicStyledComponent {
  items: T[]
  render: (item: T, index: number) => React.ReactElement
  isActiveItem: (item: T, index: number) => boolean
}

const ControlledSlider = <T,>({
  className,
  items,
  render,
  isActiveItem,
}: ControlledSliderProps<T>): ReactElement => (
  <ul className={clsx(className, styles.container)}>
    {items.map((item, index) => (
      <li
        key={index}
        className={clsx(styles.item, {
          [styles.active]: isActiveItem(item, index),
        })}
      >
        {render(item, index)}
      </li>
    ))}
  </ul>
)

export default ControlledSlider
